
import { ArrowRight, Database, Mail, Monitor, ShieldCheck } from 'lucide-react'
import { Link } from 'react-router-dom'

export function HowItWorks(){return <>
  <section className="public-page-hero public-container">
    <span className="public-kicker">How it works</span>
    <h1>From customer email received to reply sent, Mail Percent measures the operational steps in between.</h1>
    <p>
      Gmail or Outlook remains the inbox. Managers create the workspace and invite employees; each employee connects the work inbox they use through Google or Microsoft OAuth once.
    </p>
  </section>

  <section className="public-section public-container">
    <div className="public-process-grid">
      <article>
        <span>01</span><div className="feature-icon"><Mail/></div>
        <h3>Invite the team and connect inboxes</h3>
        <p>Managers share a secure employee link. Each employee enters their work email, joins the organisation and authorises Gmail or Outlook once from their Employee Workspace.</p>
      </article>

      <article>
        <span>02</span><div className="feature-icon"><Database/></div>
        <h3>Know when the email entered the queue</h3>
        <p>Mailbox timing gives Mail Percent the information needed to show how long an important customer email has been waiting.</p>
      </article>

      <article>
        <span>03</span><div className="feature-icon"><Monitor/></div>
        <h3>Measure response and queue movement</h3>
        <p>Provider timestamps and mailbox metadata let Mail Percent measure arrivals, replies, response cycles, backlog and workload without requiring a browser extension.</p>
      </article>

      <article>
        <span>04</span><div className="feature-icon"><ShieldCheck/></div>
        <h3>Build the operating view</h3>
        <p>Mail Percent combines timing, workload, queue pressure and response standards into the views managers use to understand the day.</p>
      </article>
    </div>
  </section>

  <section className="public-section public-section-dark">
    <div className="public-container public-split-section">
      <div>
        <span className="public-kicker dark">What Mail Percent shows you</span>
        <h2>See where response time is being lost.</h2>
        <p>Mail Percent combines arrival, reply, workload and queue context so managers can see whether delays are caused by backlog, staffing pressure or follow-through gaps.</p>
      </div>

      <div className="timeline-card">
        <div><span>Customer email arrived</span><b>09:14</b></div><i/>
        <div><span>Queue position changed</span><b>09:21</b></div><i/>
        <div><span>First response activity</span><b>09:25</b></div><i/>
        <div><span>Customer responded to</span><b>09:31</b></div>
      </div>
    </div>
  </section>

  <section className="public-section public-container public-final-cta">
    <div>
      <span className="public-kicker">Ready to close the gaps?</span>
      <h2>Start with one customer-facing team and one mailbox.</h2>
    </div>
    <Link to="/signup" className="button primary public-cta">Create an organisation <ArrowRight size={17}/></Link>
  </section>
</>}
